const GENERIC_MESSAGE = 'Something went wrong. Please try again.';
export const describeError = (error, options = {}) => {
    if (!options.includeDetails)
        return GENERIC_MESSAGE;
    if (error instanceof Error && error.message.length > 0)
        return error.message;
    if (typeof error === 'string' && error.length > 0)
        return error;
    return GENERIC_MESSAGE;
};
//# sourceMappingURL=describe-error.js.map